module.exports = __webpack_public_path__ + "5ba705f1500526e3f273e0c52d01ce3d.png";